import Layout from '../../internal/Layout.vue'
import StockPage from './stock.vue'
import ManagePage from './manage.vue'

const StockRoutes = {
  component: Layout,
  children: [
    {
      name: 'stock',
      path: '/',
      component: StockPage,
      meta: {
        module: 'estoque',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'manage',
      path: 'manage',
      component: ManagePage,
      meta: {
        module: 'estoque',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default StockRoutes
